module.exports = __webpack_public_path__ + "img/skull_process.e3833831.png";